export const BusinessBookerEventCode = {
  PAGE_VISITED: 'PAGE_VISITED',
  APPLICATION_STARTED: 'APPLICATION_STARTED',

  // We received a response from the API for the booking request (the pay load of the event will contain the response from the API)
  BOOKING_API_REQUEST_PHASE_COMPLETED: 'BOOKING_API_REQUEST_PHASE_COMPLETED',
  BOOKING_API_CONFIRM_PHASE_COMPLETED: 'BOOKING_API_CONFIRM_PHASE_COMPLETED',

  RETURN_BOOKING_API_REQUEST_PHASE_COMPLETED: 'RETURN_BOOKING_API_REQUEST_PHASE_COMPLETED',
  RETURN_BOOKING_API_CONFIRM_PHASE_COMPLETED: 'RETURN_BOOKING_API_CONFIRM_PHASE_COMPLETED',

  FLEET_ACCOUNTS_API_REQUEST_COMPLETED: 'FLEET_ACCOUNTS_API_REQUEST_COMPLETED',
  CREATE_CORPO_ADMIN_API_REQUEST_FAILED: 'CREATE_CORPO_ADMIN_API_REQUEST_FAILED',

  CREATE_EMPLOYEE_API_REQUEST_COMPLETED: 'CREATE_EMPLOYEE_API_REQUEST_COMPLETED',
  CREATE_EMPLOYEE_API_REQUEST_FAILED: 'CREATE_EMPLOYEE_API_REQUEST_FAILED',
  IMOPRT_EMPLOYEES_API_REQUEST_COMPLETED: 'IMOPRT_EMPLOYEES_API_REQUEST_COMPLETED',
};
